<template>
  <div class="user_password">
    <UserHead/>
    <UserNavi/>
    <div class="user_password_main">
      <div class="user_password_one">
        <div class="user_password_left">
          输入新密码
        </div>
        <div class="user_password_right">
          <input type="password" class="user_password_input" v-model="password" placeholder="请输入至少6位字符"/>
        </div>
      </div>
      <div class="user_password_one">
        <div class="user_password_left">
          重复新密码
        </div>
        <div class="user_password_right">
          <input type="password" class="user_password_input" v-model="repassword" placeholder="请输入至少6位字符"/>
        </div>
      </div>
      <div class="user_password_message" v-if="isable > 0">
        <div class="user_password_left">
          <span v-if="isable===1" style="color:green;">密码校验通过</span>
          <span v-if="isable===2" style="color:red;">错误提示</span>
        </div>
        <div class="user_password_right">
          <span style="color:red;" v-if="isable===2">{{errmsg}}</span>
        </div>
      </div>
      <div class="user_password_bottom">
        <div class="user_password_submit" v-if="isable===1 && password != null && password !== ''" @click="passSubmit">
          确认修改
        </div>
        <div class="user_password_nosub" v-if="isable!==1 || password == null || password === ''">
          确认修改
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { wxPasswordChange } from '../../api/api'
  import { getJsonStorage } from "../../util/storage";
  import UserHead from './head'
  import UserNavi from './navi'

  export default {
    name: "UserUsed",
    components: {
      UserHead,
      UserNavi
    },
    data() {
      return {
        browserType: this.$browserType,
        user: getJsonStorage('openai_user'),
        password: '',
        repassword: '',
        isable:0,
        errmsg:''
      }
    },
    mounted(){

    },
    methods:{
      passSubmit(){
        if(this.password==null || this.password.length<6 || this.password !== this.repassword){
          this.$message.warning('密码输入有误,请检查后输入');
          return;
        }
        wxPasswordChange(this.password,this.repassword).then(res => {
          if(res && res.status === 0){
            this.$message.success('密码修改成功');
            this.password = null;
            this.repassword = null;
            this.isable = 0;
            this.errmsg = '';
          }else{
            this.$message.error('密码修改失败:'+res.message);
          }
        })
      }
    },
    watch:{
      password(val,oval){
        if(val != null && val !== ''){
          if(val.length < 6){
            this.isable = 2;
            this.errmsg = '密码至少6位字符'
          }else if(this.repassword != null && this.repassword !== ''){
            if(this.repassword !== val){
              this.isable = 2;
              this.errmsg = '两次密码输入不一致'
            }else{
              this.isable = 0;
              this.errmsg = ''
            }
          }else{
            this.isable = 0;
            this.errmsg = ''
          }
        }
      },
      repassword(val,oval){
        if(val != null && val !== ''){
          if(val.length < 6){
            this.isable = 2;
            this.errmsg = '密码至少6位字符'
          }else  if(this.password !== val){
            this.isable = 2;
            this.errmsg = '两次密码输入不一致'
          }else{
            this.isable = 1;
            this.errmsg = ''
          }
        }
      }
    }
  }
</script>

<style scoped>
  .user_password {
    top:6vh;
    left:0;
    position: absolute;
    height:93vh;
    width:100%;
    margin:0;
  }
  .user_password_main {
    width:94%;
    height:76vh;
    margin: 1vh 3%;
    border: 1px solid #ccc;
    border-radius: 1rem;
  }
  .user_password_message {
    width:90%;
    margin: 1vh 5%;
    height: 3vh;
    line-height:3vh;
    font-size:.8rem;
  }
  .user_password_one {
    width:90%;
    margin: 2vh 5%;
    height: 5vh;
    line-height:5vh;
    font-size:.9rem;
    border-bottom: 1px solid #ccc;
  }
  .user_password_left {
    width:25%;
    margin-left:5%;
    float:left;
    color:grey;
    text-align:left;
  }
  .user_password_right {
    width:60%;
    margin-left:10%;
    float:right;
    color:grey;
    text-align:left;
  }
  .user_password_input {
    border: none;
    outline:none;
  }
  .user_password_bottom {
    position:absolute;
    bottom:5vh;
    left: 0;
    width:100%;
    text-align:center;
    height:5vh;
    line-height:5vh;
  }
  .user_password_submit {
    width:80%;
    margin: 0 auto;
    height:5vh;
    line-height:5vh;
    text-align:center;
    color:white;
    background-color: #409eff;
    border-radius:.5rem;
    font-size:.95rem;
  }
  .user_password_nosub {
    width:80%;
    margin: 0 auto;
    height:5vh;
    line-height:5vh;
    text-align:center;
    border-radius:.5rem;
    font-size:.95rem;
    background-color: #eee;
    color: #999;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/password.vue